export default "__VITE_ASSET__Dv$hwWur__"